import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function changeCoinIndex(coinId, index) {
  const url = `${backendUrl}/api/widgets/user-assets/?coin_id=${coinId}&new_index=${index}`;
  try {
    const response = await fetchWithAuth(url, {
      method: 'PATCH',
    });
    if (!response.ok) {
      throw new Error(`Network error: HTTP ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error changing coin index:', error);
    throw error;
  }
}